import { useIntl } from "react-intl";

const useTranslate = () => {
    const { formatMessage } = useIntl();

    return (id: string, values?: Record<string, any>) => formatMessage({ id }, values);
};

export default useTranslate;
